import { connect } from "react-redux";

import ProductSummary from "app/pages/.shared/ProductSummary/ProductSummary";

const mapStateToProps = state => ({
	booking: state.booking,
	ficheProduit: state.ficheProduit,
	status: state.status,
});

export default connect(mapStateToProps)(ProductSummary);
